import { initializeApp } from "firebase/app";
import { getAuth, onAuthStateChanged } from "firebase/auth";
import { collection, getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";

const firebaseConfig = {
  apiKey: "AIzaSyBsYWJhv4zRKNiv3wMHRdK696YxyOjvk0g",
  authDomain: "edunova-455712.firebaseapp.com",
  projectId: "edunova-455712",
  storageBucket: "edunova-455712.firebasestorage.app",
  messagingSenderId: "964317129318",
  appId: "1:964317129318:web:a343fcbbfe33ba3002dba7",
  measurementId: "G-NDDTGWQKGP",
};

const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);

const db = getFirestore(app);
export const usersCollection = collection(db, "users");

export const getIdToken = async (forceRefresh = false) => {
  return new Promise<string>((resolve, reject) => {
    onAuthStateChanged(auth, async (user) => {
      if (user) {
        try {
          const idToken = await user.getIdToken(forceRefresh);
          resolve(idToken);
        } catch (error) {
          reject(error);
        }
      } else {
        reject(new Error("No user is logged in"));
      }
    });
  });
};

export const storage = getStorage(app);
